import Vue from 'vue'
import util from '@/utils/index'

// 全局引入验证组件
import {
    localize,
    ValidationProvider,
    ValidationObserver,
    extend
} from "vee-validate";
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

// 验证规则
import {
    required,
    digits,
    alpha_num,
    numeric,
    min,
    max,
    min_value
} from "vee-validate/dist/rules";
// 最小长度
extend('min', min);
// 最大长度
extend('max', max);
// 字母和数字
extend('alpha_num', alpha_num);
// 数字
extend('numeric', numeric);
// 指定长度数字
extend('digits', digits);
// 必填验证
extend('required', required);
// 最小数字
extend('min_value', min_value);

// 身份证验证
extend('idCard', (value) => {
    return util.isIdCard(value) || '证件号码格式不正确';
});

// 身份证验证
extend('bankNo', (value) => {
    return util.luhnCheck(value) || '银行卡号不正确';
});
// 手机号码验证
extend('mobile', (value) => {
    return util.regexVerify(/^1[3|4|5|6|7|8|9][0-9]{9}$/, value) || '手机号码格式不正确';
});
// 油卡号验证
extend('oil', (value) => {
    return util.regexVerify(/^100011\d{13}$/, value) || '油卡号码格式不正确';
});

// 正整数
extend('positiveInteger', (value) => {
    return util.regexVerify(/^[+]{0,1}(\d+)$/, value) || '只能输入数字';
});

// 姓名验证
extend('name', (value) => {
    return util.regexVerify(/^[\u4E00-\u9FA5]{1,10}$/, value) || '姓名格式错误';
});

// 姓名验证
extend('password', (value) => {
    return util.regexVerify(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,12}$/, value) || '密码由6-12位大小写字母、数字组成';
});

extend('newPassWord', {
    params: ['target'],
    validate(value, {
        target
    }) {
        return value != target;
    },
    message: '新密码和旧密码不能相同'
});


extend('passwordTwo', {
    params: ['target'],
    validate(value, {
        target
    }) {
        return value === target;
    },
    message: '新密码和确认新密码必须一致'
});

// 本地化
import zh from 'vee-validate/dist/locale/zh_CN.json';
localize('zh_CN', zh)